import React from 'react';
import { Box, Typography, Grid, Container } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const stages = [
  { stage: 'New Lead', color: '#6366f1', count: '245', desc: 'Portal, walk-in, referral', num: '01' },
  { stage: 'Site Visit', color: '#0891b2', count: '89', desc: 'Scheduled & completed', num: '02' },
  { stage: 'Negotiation', color: '#f59e0b', count: '34', desc: 'Pricing discussion stage', num: '03' },
  { stage: 'Booked', color: '#10b981', count: '18', desc: 'Agreement signed', num: '04' },
  { stage: 'Closed', color: '#22d3ee', count: '12', desc: 'Handover completed', num: '05' },
];

const modules = [
  { title: 'Lead Aggregation', accentColor: '#6366f1', points: ['Capture from MagicBricks, 99acres, Housing.com', 'Website enquiry forms', 'Walk-in reception app', 'Social media & WhatsApp leads', 'Auto-deduplication'] },
  { title: 'Follow-up Engine', accentColor: '#0891b2', points: ['Smart follow-up sequences', 'WhatsApp, SMS, Email automation', 'Call log syncing from mobile', 'Hot/Warm/Cold lead tagging', 'Missed follow-up alerts'] },
  { title: 'Inventory Management', accentColor: '#22d3ee', points: ['Unit-wise availability tracker', 'Tower, floor & facing filters', 'Pricing with discount controls', 'Booking hold management', 'Real-time inventory sync'] },
];

const PipelineSection = () => (
  <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: '#f8fafc' }}>
    <Container maxWidth="lg">
      <Box sx={{ textAlign: 'center', mb: 8 }}>
        <Typography sx={{ color: '#0891b2', fontWeight: 700, fontSize: 13, letterSpacing: 2, mb: 1.5, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase' }}>Sales Pipeline</Typography>
        <Typography variant="h2" sx={{ fontWeight: 800, color: '#0f172a', fontFamily: "'Montserrat', sans-serif", fontSize: { xs: '1.8rem', md: '2.6rem' } }}>
          Full Visibility from Lead to Closure
        </Typography>
      </Box>

      {/* Pipeline — ALL STAGES VISIBLE, NO SCROLL — responsive Grid */}
      <Box sx={{ mb: 8 }}>
        <Grid container spacing={2} alignItems="stretch">
          {stages.map((s, i) => (
            <React.Fragment key={i}>
              <Grid item xs={12} sm={6} md sx={{ display: 'flex' }}>
                <Box sx={{
                  flex: 1,
                  bgcolor: '#fff',
                  borderRadius: '20px',
                  p: 3,
                  borderTop: `4px solid ${s.color}`,
                  boxShadow: `0 4px 24px ${s.color}15`,
                  transition: 'all 0.25s',
                  '&:hover': { transform: 'translateY(-6px)', boxShadow: `0 16px 40px ${s.color}28` },
                }}>
                  {/* Stage number badge */}
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                    <Typography sx={{ color: '#94a3b8', fontSize: 11, fontWeight: 800, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase', letterSpacing: 1 }}>{s.stage}</Typography>
                    <Box sx={{ width: 28, height: 28, borderRadius: '8px', bgcolor: `${s.color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Typography sx={{ color: s.color, fontWeight: 900, fontSize: 11 }}>{s.num}</Typography>
                    </Box>
                  </Box>
                  <Typography sx={{ color: s.color, fontWeight: 900, fontSize: '2.4rem', fontFamily: "'Montserrat', sans-serif", lineHeight: 1, mb: 1 }}>{s.count}</Typography>
                  <Typography sx={{ color: '#94a3b8', fontSize: 12.5, fontFamily: "'Montserrat', sans-serif" }}>{s.desc}</Typography>
                </Box>
              </Grid>
              {/* Arrow — between cards on desktop only */}
              {i < stages.length - 1 && (
                <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', alignSelf: 'center', color: '#cbd5e1', flexShrink: 0, mx: -0.5 }}>
                  <ArrowForwardIcon sx={{ fontSize: 16 }} />
                </Box>
              )}
            </React.Fragment>
          ))}
        </Grid>
      </Box>

      {/* Feature modules — equal height cards */}
      <Grid container spacing={4}>
        {modules.map((m, i) => (
          <Grid item xs={12} md={4} key={i} sx={{ display: 'flex' }}>
            <Box sx={{
              bgcolor: '#fff', borderRadius: '20px', p: 4,
              boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
              border: '1px solid #e2e8f0',
              borderLeft: `4px solid ${m.accentColor}`,
              width: '100%',
              display: 'flex', flexDirection: 'column',
            }}>
              <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a', mb: 2.5, fontFamily: "'Montserrat', sans-serif" }}>{m.title}</Typography>
              {m.points.map((p, j) => (
                <Box key={j} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: 1.4 }}>
                  <Box sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: m.accentColor, mt: '6px', flexShrink: 0 }} />
                  <Typography sx={{ color: '#475569', fontSize: 14, fontFamily: "'Montserrat', sans-serif", lineHeight: 1.65 }}>{p}</Typography>
                </Box>
              ))}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default PipelineSection;
